import { render, staticRenderFns } from "./PowerHistory.vue?vue&type=template&id=4dcf9f05"
import script from "./PowerHistory.vue?vue&type=script&lang=js"
export * from "./PowerHistory.vue?vue&type=script&lang=js"
import style0 from "./PowerHistory.vue?vue&type=style&index=0&id=4dcf9f05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports